
import moment from "moment";

function getCurrentMinDate() {
    const now = moment();
    const oneHourLater = now.clone().add(1, 'hour');
    const remainder = oneHourLater.minute() % 10;
    if (remainder > 0) {
        oneHourLater.add(10 - remainder, 'minutes');
    }
    const closingTime = now.clone().set({ hour: 17, minute: 30, second: 0 });
    return oneHourLater.isBefore(closingTime) ? oneHourLater : oneHourLater.add(1, 'day');
}
function getDefaultStartTime(fromDate) {
    let now = moment();
    let oneHourLater = now.clone().add(1, 'hour');
    const remainder = oneHourLater.minute() % 10;
    if (remainder > 0) {
        oneHourLater.add(10 - remainder, 'minutes');
    }
    const openingTime = now.clone().set({ hour: 8, minute: 0 });
    const closingTime = now.clone().set({ hour: 17, minute: 30 });

    if ( (fromDate === null || fromDate.format('YYYY-MM-DD') == now.format('YYYY-MM-DD') )   && oneHourLater.isBetween(openingTime, closingTime)  ) {
        return oneHourLater;
    }
    else {
        return oneHourLater.add(1,'day').hour(8).minutes(0).seconds(0).milliseconds(0);
    }
}
function getDefaultEndTime(pickupTime, pickupDate) {
    let pickupMoment = null;
    if (pickupTime && pickupDate) {
        pickupMoment = moment(`${pickupDate.format('DD-MM-YYYY')} ${pickupTime.format('HH:mm')}`, 'DD-MM-YYYY HH:mm');
    }
    else {
        if (pickupDate) {
            pickupMoment = moment(`${pickupDate.format('DD-MM-YYYY')} 8:00`, 'DD-MM-YYYY HH:mm');
        }
        else {
            let now = getCurrentMinDate();
            if (pickupTime) {
                pickupMoment = moment(`${now.format('DD-MM-YYYY')} ${pickupTime.format('HH:mm')}`, 'DD-MM-YYYY HH:mm');
            }
            else {
                pickupMoment = getCurrentMinDate();
            }
        }
    }

    let returnMoment = pickupMoment.clone().add(24, 'hours');
    const openingTime = returnMoment.clone().set({ hour: 8, minute: 0 });
    const closingTime = returnMoment.clone().set({ hour: 17, minute: 30 });
    return returnMoment.isBetween(openingTime, closingTime) ? returnMoment : returnMoment.hour(8).minutes(0).seconds(0).milliseconds(0);
}
function getDefaultEndDate(pickupDate, hire) {

    let pickupMoment = null;
    if (pickupDate) {
        pickupMoment = moment(`${pickupDate.format('DD-MM-YYYY')}`, 'DD-MM-YYYY');
    }
    else
        pickupMoment = getCurrentMinDate();
    let addDefault = hire == 'local'? 24:48;
    let returnMoment = pickupMoment.clone().add(addDefault, 'hours');
    const openingTime = returnMoment.clone().set({ hour: 8, minute: 0 });
    const closingTime = returnMoment.clone().set({ hour: 17, minute: 30 });
    return returnMoment.isBetween(openingTime, closingTime) ? returnMoment : returnMoment.hour(8).minutes(0).seconds(0).milliseconds(0);
}
function getDisabledHours(fromDate, fromTime, is_return, toDate) {
    const workStart = 8;
    const workEnd = 17;
    let dh = [0, 1, 2, 3, 4, 5, 6, 7, 18, 19, 20,21, 22, 23];

    let current = getCurrentMinDate();
    let todayDisabled = [];

    for (let i=0; i < Math.max(workStart,(current.hour()+1) ); i++) {
        todayDisabled.push(i);
    }
    for (let i = workEnd+1; i < 24; i++) {
        todayDisabled.push(i);
    }

    let fromTimeMoment = null;
    let minReturnHour = workStart;

    if (is_return) {
        //console.log('return_date hours')
        let hourStart = workStart;

        if (fromDate && toDate) {
            //console.log('both date exists')
            dh = [0,1,2,3,4,5,6,7];
            if ((current.isSame(toDate, 'day') || fromDate.isSame(toDate, 'day'))) {
                //console.log('current or from date is same')
                if (current.isSame(toDate, 'day') && current.hour() + 1 < workEnd) {
                    hourStart = ((current.hour() + 1) < workStart) ? workStart : current.hour() + 1;
                } else {
                    hourStart = workStart + 1;
                }
                //console.log('hour start ' + hourStart)
                fromTimeMoment = fromTime ? fromTime : moment(`${hourStart}:00`, 'HH:mm');
                minReturnHour = fromTimeMoment.hour() + 1;
            }
            //console.log('min return time ' + minReturnHour)

            if (minReturnHour <= workEnd) {

                for (let hour = workStart; hour < minReturnHour; hour++) {
                    dh.push(hour);
                }
                for (let hour = workEnd + 1; hour < 24; hour++) {
                    dh.push(hour);
                }
            } else {
                for (let hour = 0; hour < 24; hour++) {
                    dh.push(hour);
                }
            }
        }
        else {
            //console.log('something date not exists')
            //console.log( toDate ? 'toDate': (fromDate ? 'fromDate' : 'Both') + ' date not exists')
            const dateMoment = toDate ? toDate : (fromDate ? fromDate : current);
            if (current.isSame(dateMoment, 'day')) {
                //console.log('current date is same')
                dh = [];
                if (current.hour() + 1 < workEnd) {
                    hourStart = (current.hour() + 1 < workStart) ? workStart : current.hour() + 1;
                    fromTimeMoment = fromTime ? fromTime : moment(`${hourStart}:00`, 'HH:mm');
                    minReturnHour = fromTimeMoment.hour() + 1;
                }
                if (minReturnHour <= workEnd) {
                    for (let hour = workStart; hour < minReturnHour; hour++) {
                        dh.push(hour);
                    }
                    for (let hour = workEnd + 1; hour < 24; hour++) {
                        dh.push(hour);
                    }
                } else {
                    for (let hour = 0; hour < 24; hour++) {
                        dh.push(hour);
                    }
                }
            }
        }
    }
    else {
        if (fromDate === null || current.format('DD-MM-YYYY')===fromDate.format('DD-MM-YYYY')) {
            dh = [0,1,2,3,4,5,6,7];
            for (let i=0; i < Math.max(8,(current.hour()+1) ); i++) {
                dh.push(i);
            }
            for (let i = 18; i < 24; i++) {
                dh.push(i);
            }
        }
    }
    return dh;
}

function getCurrentMinDate_OLD() {
    let startMinDate = moment();
    startMinDate.hours(0).minutes(0).seconds(0).milliseconds(0);
    let minDate = moment().add(1, 'h');
    if ((minDate.hour() === 17 && minDate.minute() >= 30) || minDate.hour() > 17) {
        startMinDate.add(1, 'd');
    }
    //console.log(startMinDate.format("YYY-MM-DD"));
    return startMinDate;
}
function getDefaultStartTime_OLD(fromDate)  {
    let to_return = moment().hours(0).minutes(0).seconds(0).milliseconds(0);
    let m = moment() /* .hour(0).minutes(1) */ /*.hours(23).minutes(1)*/; // uncomment to test side
    let n = m.format("YYYY-MM-DD");
    if(fromDate === null || fromDate.format("YYYY-MM-DD") === n) { //meaning today
        if(m.hour() < 7 || m.hour() === 23) // 23 is not possible here since if it past 16:30 fromDate can not be today
            to_return.hours(8);//if current is prior 7 then early start date is 8
        else
            to_return.hours(m.hour() + 1).minutes(m.minutes()); //
    }
    else {
        if(m.hour() < 7 || m.hour() === 23)
            to_return.hours(8);//if current is prior 7 then early start date is 8
        //else if(m.hour() < 23)
        else
            to_return.hours(m.hour() + 1).minutes(m.minutes()); //
    }
//    console.log(to_return.format('hh-mm-ss'));
    return to_return;
}
function getDefaultEndTime_OLD(fromTime, fromDate) {
    let to_return = fromTime === null ? getDefaultStartTime(fromDate).clone() : fromTime.clone();
    if(to_return.hour() === 22 || to_return.hour() === 23)
        return to_return.hours(23).minutes(50);
    return to_return.add(2,'h')/*.add(10,'m')*/;
}

export {getCurrentMinDate, getDisabledHours, getDefaultStartTime, getDefaultEndTime, getDefaultEndDate};
